import { render, staticRenderFns } from "./UnitChip.vue?vue&type=template&id=0d11d856&scoped=true&"
import script from "./UnitChip.vue?vue&type=script&lang=js&"
export * from "./UnitChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d11d856",
  null
  
)

export default component.exports